import gsap from 'gsap';

export const toggleTimeline = (state: boolean, timeline: GSAPTimeline, callback?: VoidFunction) => {
  const progress = state ? 1 : 0;
  const duration = state ? 1.5 : 0.5;
  gsap
    .to(timeline, {
      progress,
      duration,
    })
    .then(callback || null);
};
